module.exports = __webpack_public_path__ + "img/CUFFXLBP.7da24154.jpg";